import { useDashboardLocaleStore } from '@/presentation/dashboard/useDashboardLocaleStore';
import { getRoleDashboardConfig } from '@/presentation/dashboard/getRoleDashboardConfig';

export function useRoleDashboardConfig(session) {
  const locale = useDashboardLocaleStore((s) => s.locale);
  return getRoleDashboardConfig(session?.role, locale);
}
